<template>
    <main class="bgcheckout" style="min-height: 100%;">
        <div class="boxcontainer">
            <v-img :src="require('@/assets/img/los-piura-andes.png')" class="logoretina"
                style="max-width: 550px; margin-left: 10px;"></v-img>
            <div class="contenido">
                <h2>UDEP Online : {{ plan.programname }}</h2>
                <h3>{{ plan.programdesc }}</h3>

                <div class="h_line"></div>
                <div style="margin-left: 5px; ">
                    <v-row>
                        <v-col cols="12" sm="4">
                            <v-list-item two-line>
                                <v-list-item-content style=" padding-left: 10px; color:#ffffff">
                                    <v-list-item-title> Precio del Programa : {{ plan.programprice
                                        }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-list-item two-line>
                                <v-list-item-content
                                    style="border-left: 1px solid #0066ff; padding-left: 10px; color:#ffffff">
                                    <v-list-item-title> Cuotas: {{ plan.dues }}</v-list-item-title>

                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-list-item two-line>
                                <v-list-item-content
                                    style="border-left: 1px solid #0066ff; padding-left: 10px; color:#ffffff">
                                    <v-list-item-title> Precio Cuota : {{ plan.amount }}</v-list-item-title>

                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                    </v-row>
                </div>
                <div>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field v-model="plan.dni" label="DNI" filled dark dense :rules="nameRules"
                                        type="number" @keypress="filterNumber(event)"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field v-model="plan.fname" label="Nombre" filled dark dense
                                        :rules="nameRules"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field v-model="plan.sname" label="Segundo Nombre" filled dark dense
                                        :rules="nameRules"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field v-model="plan.lname" label="Apellido" filled dark dense
                                        :rules="nameRules"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field v-model="plan.lsname" label="Segundo Apellido" filled dark dense
                                        :rules="nameRules"></v-text-field>
                                </v-col>
                            </v-row>


                            <v-row>
                                 <v-col cols="12" sm="12" md="4">
                                    <v-select v-model="generoSelected" :items="generos" required
                                        item-text="label" item-value="value" 
                                        :rules="[v => !!v || 'Debe seleccionar Género']" filled dark dense
                                        label="Género"></v-select>
                                 </v-col>
                                 <v-col cols="12" sm="12" md="4">
                                    <v-select v-model="estadoCivilSelected" :items="estadosciviles" required
                                        item-text="label" item-value="value" 
                                        :rules="[v => !!v || 'Debe seleccionar Estado Civil']" filled dark dense
                                        label="Estado Civil"></v-select>
                                 </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-dialog
                                        ref="dialog"
                                        v-model="modal"
                                        :return-value.sync="date"
                                        persistent
                                        width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            
                                            <v-text-field v-model="computedDateFormatted"
                                                v-bind="attrs"
                                                v-on="on" 
                                                    label="Fecha Nacimiento" filled dark dense
                                                :rules="[isAdult]" readonly></v-text-field>
                                        </template>

                                        <v-date-picker
                                            v-model="date"
                                            locale="es"
                                            :first-day-of-week="1"
                                            scrollable
                                            :max="maxBirthdate"
                                        >
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="modal = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text color="primary" @click="$refs.dialog.save(date)">
                                            OK
                                        </v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field v-model="plan.email" label="Correo Electrónico" filled dark dense
                                        :rules="emailRules" disabled></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field v-model="plan.phone" label="Teléfono" filled dark dense
                                        :rules="nameRules"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="4">
                                    <v-select v-model="departamentoSelected" :items="departamentos" required
                                        item-text="nombre_ubigeo" item-value="id_ubigeo" dense
                                        :rules="[v => !!v || 'Debe seleccionar el departamento']" filled dark
                                        label="Departamento" @change="changeDepartamento()"></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-select v-model="proviciaSelected" :items="provinciasbyubigeo"  required
                                        item-text="nombre_ubigeo" item-value="id_ubigeo" dense
                                        :rules="[v => !!v || 'Debe seleccionar la provincia']" filled dark
                                        label="Provincia" @change="changeProvincia()"></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-select v-model="distritoSelected" :items="distritobyubigeo"  required
                                        item-text="nombre_ubigeo" item-value="id_ubigeo" dense
                                        :rules="[v => !!v || 'Debe seleccionar el distrito']" filled dark
                                        label="Distrito"></v-select>
                                </v-col>

                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="plan.address" label="Dirección" filled dark dense
                                        :rules="nameRules"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="4">
                                    <v-select v-model="nivelEstudioSelected" :items="nivelesestudio" required
                                        item-text="label" item-value="value" 
                                        :rules="[v => !!v || 'Debe seleccionar Nivel de Estudio']" filled dark dense
                                        label="Nivel Estudio"></v-select>
                                 </v-col>
                                 <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="plan.academic_title" label="Carrera de pregrado" filled dark dense
                                        :rules="nameRules"></v-text-field>
                                </v-col>
                                 <v-col cols="12" sm="12" md="4">
                                    <v-select v-model="institucionEstudioSelected" :items="institucionesestudio" required
                                        item-text="label" item-value="value" 
                                        :rules="[v => !!v || 'Debe seleccionar Institución de pregrado']" filled dark dense
                                        label="Institución de pregrado"></v-select>
                                 </v-col>
                            </v-row>
                            <v-row>
                                 <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="plan.nationality" label="Nacionalidad" filled dark dense
                                        :rules="nameRules"></v-text-field>
                                </v-col>
                                 <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="plan.childs" label="Número de hijos" filled dark dense
                                        type="number" min="0" :rules="numberRules"
                                        @keypress="filterNumber(event)"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                 <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="plan.job_company" label="¿Donde trabajas actualmente?" filled dark dense
                                        :rules="nameRules"></v-text-field>
                                </v-col>
                                 <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="plan.job_position" label="Cargo" filled dark dense
                                        :rules="nameRules"></v-text-field>
                                </v-col>
                                 <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="plan.job_yearsexperience" label="Años de experiencia" required filled dark dense
                                        type="number" min="0" :rules="numberRules"
                                        @keypress="filterNumber(event)"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="6">
                                    <v-file-input v-model="dnicopy" label="Subir DNI" filled dark dense
                                        :rules="fileRules" accept="image/*,.pdf"
                                        show-size></v-file-input>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-file-input v-model="titulocopy" label="Subir Título" filled dark dense
                                        :rules="fileRules" accept="image/*,.pdf"
                                        show-size></v-file-input>
                                </v-col>
                                <v-col>
                                    <v-checkbox v-model="terms" color="#0066ff" value="aceptado" dark
                                        :rules="[v => !!v || 'Debe aceptar los terminos para continar!']">
                                        <template v-slot:label>
                                            <div>
                                                Debe aceptar los

                                                <template>
                                                    <a target="_blank"
                                                        :href="terminos"
                                                        @click.stop>
                                                        Terminos y Condiciones
                                                    </a>
                                                </template>
                                                y el
                                                <a target="_blank"
                                                    :href="reglamento"
                                                    @click.stop>
                                                    Reglamento Academico
                                                </a>
                                            </div>
                                        </template>
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </div>
                <div class="text-center pb-10" style="width: 50%; text-align: center;  margin: auto;">
                    <v-btn rounded :loading="btnloading" color="#0066ff" dark block @click="validate()">
                        Inscribirse
                    </v-btn>
                </div>
                <div class="condiciones_footer pb-15">Los precios base que manejamos son en soles peruanos. El cargo
                    final podría variar de acuerdo a tu medio de pago, banco y el tipo de cambio del día, además de
                    estar sujeto a
                    impuestos
                    propios de cada país, los cuales serán asumidos por los usuarios finales. Los pagos en cuotas se
                    realizarán
                    automaticamente el mismo día del pago cada mes hasta completar la cantidad de cuotas.
                </div>
            </div>

        </div>

        <v-snackbar v-model="snackbarError" color="error" timeout="8000" top>
            No se pudo obtener el enlace de pago, recarga la página o contacta soporte
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbarError = false">
                    Cerrar
                </v-btn>
            </template>
        </v-snackbar>

    </main>
</template>

<script>

/* eslint-disable */
import planServices from '@/services/plan.services'
import enumsServices from '@/services/enums.services'
import departamentos from '@/assets/geo/departamentos.json'
import provincias from '@/assets/geo/provincias.json'
import distritos from '@/assets/geo/distritos.json'


export default {
    name: 'CheckOut',
    data() {
        return {

            terminos: new URL('/src/assets/tyc/2024_12_01_Terminos_y_Condiciones_UDEP_UANDES_v1.pdf', import.meta.url).href,
            reglamento: new URL('/src/assets/tyc/2024_05_03_Reglamento_Academico_UDEP_UANDES_v1.pdf', import.meta.url).href,
            btnloading: false,
            valid: true,
            id: this.$route.query.gd,
            departamentos: [],
            provinciasbyubigeo: [],
            distritobyubigeo: [],
            generos: [],
            estadosciviles: [],
            nivelesestudio: [],
            institucionesestudio: [],
            date: this.getDefaultBirthdate(),
            modal: false,
            dateFormatted: null,
            plan: {
                programname: '',
                programdesc: '',
                programprice: '',
                dues: '',
                amount: '',
                dni: '',
                fname: '',
                lname: '',
                sname: '',
                lsname: '',
                birthdate: null,
                gender: '',
                email: '',
                phone: '',
                address: '',
                guidp: '',
                dnicopy: '',
                titulocopy: '',
                type_payment: '',
                departamento: '',
                provincia: '',
                distrito: '',
                hsid:'',
                titulofile:null,
                gender:'',
                maritalstatus:'',
                academic_level:'',
                academic_title:'',
                academic_institucion:'',
                nationality:'',
                childs:0,
                job_company:'',
                job_position:'',
                job_yearsexperience:null
            },
            departamentoSelected: '',
            proviciaSelected: '',
            distritoSelected: '',
            generoSelected: '',
            estadoCivilSelected: '',
            nivelEstudioSelected: '',
            institucionEstudioSelected: '',
            plantoken: '',
            snackbarError: false,
            uri_base_dlocal: process.env.VUE_APP_URI_CHECKOUT_PLAN,
            dnicopy: undefined,
            titulocopy: undefined,
            terms: false,

            nameRules: [
                v => !!v || 'Datos requeridos',
                v => (v && v.toString().length >= 3) || 'El campo debe tener al menos 3 characteres',
            ],
            nameRules2: [
                v => {
                    if (v === 0 || v === '0') {
                        return true;
                    }

                    if (typeof v === 'string') {
                        return v.trim().length > 0 || 'Datos requeridos';
                    }

                    return (v !== null && v !== undefined) || 'Datos requeridos';
                },
                v => {
                    if (v === null || v === undefined) {
                        return 'El campo debe tener al menos 1 characteres';
                    }

                    return v.toString().trim().length >= 1 || 'El campo debe tener al menos 1 characteres';
                },
            ],
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
            maxFileSize: 25 * 1024 * 1024, // 25 MB
            fileRules: [
                v => !!v || 'Datos requeridos',
                v => !v || v.size <= 25 * 1024 * 1024 || 'El archivo no debe superar los 25 MB',
            ],
            numberRules: [
                v => (v !== null && v !== undefined && v.toString().trim().length > 0) || 'Datos requeridos',
                v => /^\d+$/.test(v.toString().trim()) || 'Debe ingresar un número válido',
            ],
        }
    },
    created: async function() {
        try {

            this.generos = (await enumsServices.getGenders()).data;
            this.estadosciviles = (await enumsServices.getMaritalStatus()).data;
            this.nivelesestudio = (await enumsServices.getAcademicsLevels()).data;
            this.institucionesestudio = (await enumsServices.getAcademicsInstitutions()).data;

            var dataPlan = await planServices.postplanbyguid(this.id);
            if (dataPlan.data) {
                // La URL de pago se asigna primero: un fallo en el prellenado de selects
                // no debe impedir la redirección a Mercado Pago
                this.plantoken = dataPlan.data.mp_checkout_url;
                this.plan.programname = dataPlan.data.program.name;
                this.plan.programdesc = dataPlan.data.description;
                this.plan.dues = dataPlan.data.dues;
                this.plan.amount = dataPlan.data.amount;
                this.plan.programprice = dataPlan.data.priceprogram;
                this.plan.dni = dataPlan.data.payer.dni;
                this.plan.fname = dataPlan.data.payer.name;
                this.plan.sname = dataPlan.data.payer.secondname;
                this.plan.lname = dataPlan.data.payer.lastname;
                this.plan.lsname = dataPlan.data.payer.secondlastname;
                this.plan.email = dataPlan.data.payer.email;
                this.plan.phone = dataPlan.data.payer.phone;
                this.plan.address = dataPlan.data.payer.address;
                this.plan.guidp = dataPlan.data.payer.guid;
                this.plan.dnicopy = dataPlan.data.payer.dnidoc;
                this.plan.titulocopy = dataPlan.data.payer.certificatedoc;
                this.plan.type_payment = dataPlan.data.type_payment;
                this.plan.hsid = dataPlan.data.payer.hsid
                this.plan.birthdate = dataPlan.data.payer.birthdate;
                if (this.plan.birthdate) {
                    this.date = this.parseDateFromDb(this.plan.birthdate);
                } else {
                    this.date = this.getDefaultBirthdate();
                }
                this.plan.gender = dataPlan.data.payer.gender;
                this.plan.departamento = dataPlan.data.payer.departamento;
                this.plan.provincia = dataPlan.data.payer.provincia;
                this.plan.distrito = dataPlan.data.payer.distrito;
                this.plan.maritalstatus = dataPlan.data.payer.maritalstatus;
                this.plan.academic_level = dataPlan.data.payer.academic_level;
                this.plan.academic_title = dataPlan.data.payer.academic_title;
                this.plan.academic_institucion = dataPlan.data.payer.academic_institucion;
                this.plan.nationality = dataPlan.data.payer.nationality;
                this.plan.childs = dataPlan.data.payer.childs;
                this.plan.job_company = dataPlan.data.payer.job_company;
                this.plan.job_position = dataPlan.data.payer.job_position;
                this.plan.job_yearsexperience = dataPlan.data.payer.job_yearsexperience;

                const genderLabel = this.plan.gender?.toString().toLowerCase().trim();
                const maritalStatusLabel = this.plan.maritalstatus?.toString().toLowerCase().trim();
                const academicLevelLabel = this.plan.academic_level?.toString().toLowerCase().trim();
                const academicInstitutionLabel = this.plan.academic_institucion?.toString().toLowerCase().trim();
                const departmentLabel = this.plan.departamento?.toString().toLowerCase().trim();
                const provinceLabel = this.plan.provincia?.toString().toLowerCase().trim();
                const districtLabel = this.plan.distrito?.toString().toLowerCase().trim();

                this.departamentoSelected = this.departamentos.find(
                d => d.nombre_ubigeo?.toString().toLowerCase().trim() === departmentLabel
                )?.id_ubigeo || '';
                this.changeDepartamento();

                this.proviciaSelected = this.provinciasbyubigeo.find(
                p => p.nombre_ubigeo?.toString().toLowerCase().trim() === provinceLabel
                )?.id_ubigeo || '';
                this.changeProvincia();
                this.distritoSelected = this.distritobyubigeo.find(
                d => d.nombre_ubigeo?.toString().toLowerCase().trim() === districtLabel
                )?.id_ubigeo || '';

                this.generoSelected = this.generos.find(
                g => g.label?.toString().toLowerCase().trim() === genderLabel
                )?.value || '';

                this.estadoCivilSelected = this.estadosciviles.find(
                e => e.label?.toString().toLowerCase().trim() === maritalStatusLabel
                )?.value || '';

                this.nivelEstudioSelected = this.nivelesestudio.find(
                n => n.label?.toString().toLowerCase().trim() === academicLevelLabel
                )?.value || '';
                this.institucionEstudioSelected = this.institucionesestudio.find(
                i => i.label?.toString().toLowerCase().trim() === academicInstitutionLabel
                )?.value || '';
            }

        } catch (error) {
            console.error('Error al obtener Enumeración:', error);
        }
    },
    mounted() {
        this.date = this.getDefaultBirthdate();
        this.maxBirthdate = this.getDefaultBirthdate();
    },
    async mounted() {
        this.departamentos = departamentos;
    },
    methods: {

        changeDepartamento() {
            this.provinciasbyubigeo = provincias[this.departamentoSelected] || []
        },
        changeProvincia() {
            this.distritobyubigeo = distritos[this.proviciaSelected] || []
        },

        async validate() {
            if (this.$refs.form.validate()) {
                this.btnloading = true;
                this.startCheckOut();

            }
        },

        async startCheckOut() {

            this.plan.departamento = this.departamentos.filter(x => x.id_ubigeo == this.departamentoSelected)[0].nombre_ubigeo;
            this.plan.provincia = this.provinciasbyubigeo.filter(x => x.id_ubigeo == this.proviciaSelected)[0].nombre_ubigeo;
            this.plan.distrito = this.distritobyubigeo.filter(x => x.id_ubigeo == this.distritoSelected)[0].nombre_ubigeo;
            this.plan.gender = this.generos.filter(x => x.value == this.generoSelected)[0].label;
            this.plan.maritalstatus = this.estadosciviles.filter(x => x.value == this.estadoCivilSelected)[0].label;
            this.plan.academic_level = this.nivelesestudio.filter(x => x.value == this.nivelEstudioSelected)[0].label;
            this.plan.academic_institucion = this.institucionesestudio.filter(x => x.value == this.institucionEstudioSelected)[0].label;
            this.plan.birthdate = this.formatDate(this.date);
            this.plan.terms = this.terms === 'aceptado';

            //console.log(this.plan);
            //return;
            const DNI = await this.uploadDNI();

             const TITULO = new FormData()
              const xtension = '.' + this.titulocopy.name.split('.')[1];
              TITULO.append('file', this.titulocopy, 'TITULO-' + this.plan.dni + xtension)
              this.plan.titulofile = TITULO;

            if (DNI.status == 200) {
                this.uploadTitulo().then((rsupdTitulo) => {

                    if (rsupdTitulo.status == 200) {
                        this.plan.dnicopy = this.dnicopy.name;
                        this.plan.titulocopy = this.titulocopy.name;
                        planServices.postUpdatePayer(this.plan).then((response) => {
                            //debugger;
                            if (response.status == 200) {
                                if (this.plan.type_payment == 'OC') {
                                    this.$router.push({ path: '/subscription/successfulOC/' })
                                } else if (this.plantoken && this.plantoken.toString().trim() !== '') {
                                    window.location.href = this.plantoken
                                } else {
                                    this.btnloading = false;
                                    this.snackbarError = true;
                                }
                            }
                        })
                    }
                });
            }
        },

        uploadDNI() {
            const DNI = new FormData()
            const xtension = '.' + this.dnicopy.name.split('.')[1];
            DNI.append('file', this.dnicopy, 'DNI-' + this.plan.dni + xtension)
            return planServices.postUploadFile(DNI)
        },

        uploadTitulo() {

            const TITULO = new FormData()
            const xtension = '.' + this.titulocopy.name.split('.')[1];
            TITULO.append('file', this.titulocopy, 'TITULO-' + this.plan.dni + xtension)
            return planServices.postUploadFile(TITULO)

        },


        //event key only numbers  -
        filterNumber(evt) {
            evt = (evt) ? evt : window.event;
            let expect = evt.target.value.toString() + evt.key.toString();
            if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        
        getDefaultBirthdate() {
            const d = new Date();
            d.setFullYear(d.getFullYear() - 18);
            return d.toISOString().substr(0, 10);
        },
        
        isAdult(value) {
            if (value != null && value.length > 0) {
                let dia = value.substring(0, 2);
                let mes = value.substring(3, 5);
                let anio = value.substring(6, 11);

                const hoy = new Date();
                const fechaNacimiento = new Date(`${anio}/${mes}/${dia}`)

                if (hoy.getTime() < fechaNacimiento.getTime())
                    return 'Debe seleccionar una fecha correcta';

                const edadmilisegundos = (hoy.getTime() - fechaNacimiento.getTime());
                const edad = (((edadmilisegundos / 1000) / 60) / 1440) / 365;

                if (edad < 18) return 'La edad mínima es 18 años';
                else return true;

            } else {
                return 'Debe seleccionar una fecha';
            }
        },

        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

        parseDate(date) {
            if (!date) return null
            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },

        parseDateFromDb(fechaString) {
            if (!fechaString) return null
            const [day, month, year] = fechaString.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
    },
    computed: {

        maxBirthdate() {
            const today = new Date();
            today.setFullYear(today.getFullYear() - 18);
            return today.toISOString().substr(0, 10); // yyyy-mm-dd
        },

        computedDateFormatted() {
            return this.date ? new Date(this.date).toLocaleDateString('es-CL') : '';
        },
        
        computedDateFormatted() {
            this.plan.birthdate = this.formatDate(this.date);
            return this.formatDate(this.date)
        },
    }
}
</script>

<style>
.bgcheckout {
    background: url('@/assets/img/EdificioE.jpg');
    background-repeat: no-repeat;
    background-size: cover;
}

.boxcontainer {
    margin: auto;
    margin-top: 10px;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75));
    border-radius: 10px;
    width: 98%;
    text-align: center;
}



.h_line {
    border-bottom: 1px solid #0066ff;
    margin-right: 5%;
    margin-left: 5%;
    padding-bottom: 20px;

}

.logoretina {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
}

.contenido {
    margin-left: 5px;
    margin-right: 5px;
    color: #ffffff
}

.v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
}

.condiciones_footer {
    padding-left: 30px;
    padding-right: 30px;
    color: #dfdfdf;
}

</style>

<style scoped>
.align-text-field {
  margin-top: 0px; /* Ajusta si es necesario */
  height: 56px !important; /* Altura del text-field */
}
</style>
